import { COLLECTIONS } from '../hooks/useFirebase';

class RecurringTaskService {
  constructor(updateTask) {
    this.updateTask = updateTask;
  }

  formatDateKey(date) {
    return date.toISOString().split('T')[0];
  }

  async updateTaskCompletion(taskId, checklist, assignedDays = []) {
    const now = new Date();
    const allCompleted = checklist.length > 0 && checklist.every(item => item.checked);

    try {
      const updates = {
        subtasks: checklist
      };

      // For now, treat every day as an assigned day since we're only doing daily tasks
      const dateKey = this.formatDateKey(now);

      if (allCompleted) {
        updates.completedDates = this.arrayUnion(dateKey);
      } else {
        updates.completedDates = this.arrayRemove(dateKey);
      }

      await this.updateTask(taskId, updates, COLLECTIONS.RECURRING);
    } catch (error) {
      console.error('Error updating task completion:', error);
      throw error;
    }
  }

  getCompletionStats(completedDates = [], assignedDays = []) {
    const formattedDates = new Set(completedDates || []);
    const sortedDates = [...formattedDates].sort();

    return {
      totalCompletions: completedDates.length,
      currentStreak: this.calculateCurrentStreak(sortedDates),
      longestStreak: this.calculateLongestStreak(sortedDates),
      lastCompletedAt: sortedDates[sortedDates.length - 1] || null
    };
  }

  calculateCurrentStreak(sortedDates) {
    if (sortedDates.length === 0) return 0;

    const today = this.formatDateKey(new Date());
    const yesterday = this.formatDateKey(new Date(Date.now() - 86400000));

    // If completed today, start counting from today
    // If not completed today but completed yesterday, start from yesterday
    const startDate = sortedDates.includes(today) ? today :
                     sortedDates.includes(yesterday) ? yesterday : null;

    if (!startDate || !sortedDates.includes(startDate)) return 0;

    let streak = 0;
    let currentDate = new Date(startDate);

    while (true) {
      const dateKey = this.formatDateKey(currentDate);
      if (!sortedDates.includes(dateKey)) break;

      streak++;
      currentDate.setDate(currentDate.getDate() - 1);
    }

    return streak;
  }

  calculateLongestStreak(sortedDates) {
    if (sortedDates.length === 0) return 0;

    let longestStreak = 0;
    let currentStreak = 1;

    for (let i = 1; i < sortedDates.length; i++) {
      const prevDate = new Date(sortedDates[i - 1]);
      const currDate = new Date(sortedDates[i]);
      const daysDiff = Math.round((currDate - prevDate) / (24 * 60 * 60 * 1000));

      if (daysDiff === 1) {
        currentStreak++;
        longestStreak = Math.max(longestStreak, currentStreak);
      } else {
        currentStreak = 1;
      }
    }

    return Math.max(longestStreak, currentStreak);
  }

  arrayUnion(value) {
    return {
      __type: 'arrayUnion',
      value
    };
  }

  arrayRemove(value) {
    return {
      __type: 'arrayRemove',
      value
    };
  }
}

export { RecurringTaskService };